import { Header } from "../Forms/SmartForm";
import React, { useState } from "react";
import axios from "axios";
import Modal from "../Modal/Modal";
import ModalGate from "../ModalGate/ModalGate";

const PdfSubmission = ({article ={}}) => {
    const [displayThankModal, setDisplayThankModal] = useState(false);

    const onSubmit = async (formValues) => {

        try {
            setDisplayThankModal(true);
            await axios.post(`/api/pdf-generator/${article.articleNo}`, {
                formValues
            });
        }catch (error) {
            //The errors are caught in web server and logged to rollbar
        }

        // Push datalayer event for tracking within Google Analytics (GTM)
        window.dataLayer.push({
            "event": "submitPDFFormSuccess",
            "gtmCustomClick": {
                "eventCategory": "Conversion"
            }
        });
    };

    const modalHeaderContent = () =>
        <>
            <p className="m-b-0 text-inverted">
                Complete the form below and we will email you a
                PDF version of
            </p>
            <p
                className="text-inverted bold"
                dangerouslySetInnerHTML={{
                    __html: article.articleTitle,
                }}
            ></p>
        </>;

    const ThankYouModal = () => {
        return (
            <Modal>
                <div
                    className="modal-gate"
                    id="ThankYouModal"
                >
                    <div className="modal-gate-content m-0">
                        <button
                            className="close-btn corner background-transparent no-border text-white float-right"
                            onClick={() => setDisplayThankModal(false)}
                        >
                            Close X
                        </button>
                        <Header className="p-v-1 p-h-2 m-b-0 text-center">
                            <h1 className="text-inverted">Thank you!</h1>
                            <p className="text-inverted">
                                We have emailed you a PDF version of the article
                                you requested.
                            </p>
                            <button
                                className="btn brandedButton compact inverted"
                                onClick={() => setDisplayThankModal(false)}
                            >
                                Close X
                            </button>
                        </Header>
                        <div className="form-footer background-white text-center p-v-1 p-h-2">
                            <h1>Can't find the email?</h1>
                            <p>Please check your spam or junk folder.</p>
                            <p>
                                You can also add{" "}
                                <a className="email" href={`mailto:info@labmanager.com`}>
                                    info@labmanager.com
                                </a>{" "}
                                to your safe senders list to ensure that you
                                never miss a message from us.
                            </p>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    };

    const buttonContent = (isSubmitting = true, dataAttribute = "") => {
        if (isSubmitting) {
            return <>
                <span data-attribute={dataAttribute}>SEND PDF VERSION</span>
                <i
                    className="far fa-file-pdf"
                    aria-hidden="true"
                    data-attribute={dataAttribute}
                />
            </>;
        } else {
            return <>
                <span>SEND PDF VERSION</span>
                <i
                    className="far fa-file-pdf"
                    aria-hidden="true"
                />
            </>;
        }
    };

    return (
        <div id="PdfSubmission">
            {displayThankModal && ThankYouModal()}
            <ModalGate
                onSubmit = {onSubmit}
                dataAttribute = "get-pdf-version"
                modalHeaderContent = {modalHeaderContent}
                buttonContent = {buttonContent}
                clickOpenModalEventName="clickOpenPDFModal"
                clickCloseModalEventName="clickClosePDFModal"
            />
        </div>
    );
};

export default PdfSubmission;
